import { PdRatingOverview } from "./pd-rating/PdRatingOverview.js";
//#region src/pd-rating/pd-rating-overview.ts
var tag = "pd-rating-overview";
if (!customElements.get(tag)) customElements.define(tag, PdRatingOverview);
//#endregion
export { PdRatingOverview };
